import React, { Component } from "react";
import { Link } from "react-router-dom";

class Breadcrumb extends Component {
  render() {
    const { title, parent, bgImage } = this.props;

    // Eğer özel görsel verildiyse onu kullan, yoksa varsayılan bg_image--1 devam etsin
    const backgroundStyle = bgImage
      ? {
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }
      : {};

    return (
      <React.Fragment>
        <div
          className={`breadcrumb-area rn-bg-color ptb--120 bg_image ${
            bgImage ? "" : "bg_image--1"
          }`}
          data-black-overlay="6"
          style={backgroundStyle}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb-inner pt--100">
                  <ul className="page-list"></ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Breadcrumb;
